import React, { useState } from "react";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";

function App() {
  const [user, setUser] = useState(null);

  if (!user) {
    return <LoginPage onLogin={(username) => setUser(username)} />;
  }

  return <Dashboard username={user} onLogout={() => setUser(null)} />;
}

export default App;
